// import { customerFeatureStateSlice } from '@features';
import { slice } from './slice';

// Action creators are generated for each case reducer function.
export const {
	setViewMode,
	setAccessoryDropDown,
	setSelectedAccessory,
	setRemovedAccessory,
	setCustomerFeatureFindState,
	setCommentAdded,
	setConfirmCustomerClose,
	setSaveAsDraftClose,
	setGetNewCustomerData,
	setPromotionalSkuDropdown,
	setSelectedPromotionalSku,
	setRemovedPromotionalSku,
	setPricePromotionalSku,
	setSkuPromotionalSku,
	setPromotionalDescription,
	setDeleteCustomerDraftsModal,
	setDeleteAllDraftsModal,
	setGeneratePresentationModal,
	setPushSubmissionDataModal,
	setDeleteCustomerBlueprintModal
} =
  slice.actions;

// Selectors returned by `slice.selectors` take the root state as their first argument.
export const {
	selectFeatureState,
	selectFeatureCustomerState,
	selectFeatureLayerState,
	selectFeatureValidationState,
	selectCustomerFeatureFindState,
	selectCommentAdded,
	selectConfirmCustomerClose,
	selectSaveAsDraftClose,
	selectGetNewCustomerData,
	selectViewMode,
	selectAccessoryDropdown,
	selectSelectedAccessory,
	selectRemovedAccessory,
	selectPromotionalSkuDropdown,
	selectSelectedPromotionalSku,
	selectRemovedPromotionalSku,
	selectPriceChangePromotionalSku,
	selectSkuPromotionalSku,
	selectPromotionalDescription,
	selectDeleteCustomerDraftsModal,
	selectDeleteAllDraftsModal,
	selectGeneratePresentationModal,
	selectSetPushSubmissionDataModal,
	selectDeleteCustomerBlueprintModal
} = slice.selectors;
